import * as React from "react";
import PropTypes from 'prop-types';

const SvgCustomerService = props => {
  if (props.id !== "_svgcustomerservice") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 26 26" {...props}><path d="M21.173 12.164c1.417 1.075 4.737 3.592 4.72 8.099a.648.648 0 01-.642.648c-.053 0-5.308.022-9.376.022h-.001c-1.456 0-2.6-.002-3.4-.008a80.965 80.965 0 01-1.042-.012 9.678 9.678 0 01-.3-.01c-.692-.033-.712-.596-.712-.66-.015-4.337 3.054-6.756 4.53-7.918.147-.116.298-.235.417-.334-.96-1.187-1.46-2.511-1.488-3.94-.044-2.269 1.602-4.781 4.125-4.905h.034l.152-.001h.032c2.537.125 4.191 2.637 4.147 4.906-.028 1.418-.52 2.731-1.463 3.909l.267.204zm-7.157.077c-1.32 1.076-3.23 2.864-3.95 5.646l-1.889.002-3.196.002c-1.37 0-2.325-.002-3.009-.007a68.048 68.048 0 01-.907-.01 9.504 9.504 0 01-.262-.008c-.677-.035-.697-.596-.697-.66-.015-4.338 3.054-6.756 4.53-7.918.147-.117.298-.236.417-.335-.959-1.186-1.46-2.51-1.487-3.94C3.52 2.745 5.167.233 7.69.11l.033-.001h.184c2.538.124 4.192 2.637 4.148 4.906-.028 1.418-.52 2.731-1.463 3.909l.267.203c.814.618 2.117 1.608 3.157 3.115z" /></svg>;
};

SvgCustomerService.displayName = "_svgcustomerservice";
SvgCustomerService.propTypes = {
  id: PropTypes.string
};
SvgCustomerService.defaultProps = {
  id: ''
};
export default SvgCustomerService;